import EmailTemplateEditorComponent from 'components/EmailMarketing/EmailTemplateEditor/EmailTemplateEditorComponent';
import { pageView } from 'googleAnalytics/GoogleAnalytics';
import { FunctionComponent, useEffect } from 'react';

const EmailTemplateEditor: FunctionComponent = () => {
    useEffect(() => {
        document.title = 'Email Template Editor - Cuddles';
        pageView('/marketing/emails/templates/edit');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <EmailTemplateEditorComponent />;
};

export default EmailTemplateEditor;
